import { render, staticRenderFns } from "./CampaignTemplateTable.html?vue&type=template&id=bb2ec3c4&"
import script from "./CampaignTemplateTable.component.js?vue&type=script&lang=js&"
export * from "./CampaignTemplateTable.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VTooltip})
